import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';

import breakpoints from '../../util/breakpoints';
import data from '../../data/capabilities.json';
import { KatyBio, NicoBio } from './Bio';

const Wrapper = styled(Container)`
  padding: 0;
`;

const AltHeader = styled.span`
  display: block;
  text-transform: uppercase;
  color: #9E9FCD;
  font-weight: 700;
  font-size: .8em;
  letter-spacing: 0.3em;
  padding-top: 160px;
`;

const H1 = styled.h1`
  padding-top: 15px;
  font-size: 3em;
  font-weight: 700;
  color: white;

  ${breakpoints.sm`
    font-size: 3em;
    width: 70%;
  `}

  ${breakpoints.md`
    font-size: 4em;
  `}
`;

const Title = styled.h2`
  color: white;
  font-size: 3em;
  font-weight: 700;
`;

const Subtitle = styled.span`
  color: #94a0b7;
  margin-top: 10px;
  line-height: 1.2em;
  display: block;
  font-weight: 700;
  font-size: 1.3em;
`;

const Description = styled.p`
  color: white;
  padding: 20px 80px 0 0;
`;

const TitleCol = styled(Col)`
  margin-top: 40px;
  padding-right: 80px;
  display: grid;
  align-self: center;

  ${breakpoints.lg`
    margin-top: 0;
  `}
`;

const CapabilityCol = styled(Col)`
  margin: 20px 0 80px;
  background-color: #2E3847;
  padding: 50px 0 10px 50px;

  ${breakpoints.lg`
    margin: 84px 0;
  `}
`;

const Capability = styled.div`
  display: grid;
  grid-template-areas:
    "emoji title"
    "emoji description";
  grid-template-columns: 50px 1fr;
  padding-bottom: 40px;
`;

const Emoji = styled.span`
  grid-area: emoji;
  justify-self: center;
  font-size: 2.2em;
`;

const ItemTitle = styled.p`
  grid-area: title;
  font-size: 1.5em;
  color: white;
  margin: 0;
  font-size: 1em;
  font-weight: 700;
  padding-left: 20px;
`;

const ItemDescription = styled.p`
  grid-area: description;
  color: #94a0b7;
  font-size: 1.5em;
  margin: 0;
  font-size: 1em;
  padding-left: 20px;

  ul {
    padding-left: 0;
    padding-top: 10px;
  }

  li {
    display: inline-block;
    padding-right: 20px;
  }
`;

const CapabilitiesUI = () => (
  <Wrapper>

    <Row>
      <Col>

        <AltHeader>what we do</AltHeader>
        <H1>We help small teams execute on big visions.</H1>

        <AltHeader>who we are</AltHeader>

      </Col>
    </Row>

    <Row>
      <Col xs="12" lg="6">
        <KatyBio />
      </Col>
      <Col xs="12" lg="6">
        <NicoBio />
      </Col>
    </Row>

    <Row>
      <Col>
        <AltHeader>how we can help</AltHeader>
      </Col>
    </Row>

    {data.capabilities.map((capability, i) => (
      <Row key={i}>
        <TitleCol xs="12" lg="6">
          <Title>{capability.title}</Title>
          <Subtitle>{capability.subtitle}</Subtitle>
          <Description>{capability.description}</Description>
        </TitleCol>
        <CapabilityCol xs="12" lg="6">
          {capability.items.map((item, j) => (
            <Capability key={j}>
              <Emoji dangerouslySetInnerHTML={{__html: item.emoji}} />
              <ItemTitle emoji={item.emoji}>{item.title}</ItemTitle>
              <ItemDescription dangerouslySetInnerHTML={{__html: item.subtitle}} />
            </Capability>
          ))}
        </CapabilityCol>
      </Row>
    ))}
  </Wrapper>
);

export default CapabilitiesUI;



// WEBPACK FOOTER //
// ./src/components/ui/CapabilitiesUI.js